import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import * as moment from 'moment';
import {LIST_FADE_ANIMATION} from '../../utils/list.animation';

@Component({
    selector: 'vr-toolbar-notifications',
    templateUrl: './toolbar-notifications.component.html',
    styleUrls: ['./toolbar-notifications.component.scss'],
    animations: [...LIST_FADE_ANIMATION]
})
export class ToolbarNotificationsComponent implements OnInit {

    isOpen: boolean;
    notifications: any[];
    demoTriggers = 0;

    constructor(
        private cd: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.notifications = [
            {
                icon: 'notifications',
                name: 'New query raised',
                time: 'few sec ago',
                read: false,
                colorClass: ''
            },
            {
                icon: 'shopping_basket',
                name: 'User bought Exodus',
                time: '23 min ago',
                read: false,
                colorClass: 'primary'
            },
            {
                icon: 'place',
                name: 'New field added',
                time: 'an hour ago',
                read: true,
                colorClass: 'accent'
            }
        ]
    }

    markAsRead(notification) {
        notification.read = true;
    }

    dismiss(notification) {
        this.notifications.splice(this.notifications.indexOf(notification), 1);
        this.triggerDemoNotification();
    }

    toggleDropdown() {
        this.isOpen = !this.isOpen;
        this.triggerDemoNotification();
    }

    onClickOutside() {
        this.isOpen = false;
    }

    triggerDemoNotification() {
        if (this.demoTriggers === 0) {
            this.demoTriggers++;

            setTimeout(() => {
                this.notifications.unshift({
                    icon: 'place',
                    name: 'New field added by Mani',
                    time: moment().fromNow(),
                    read: false,
                    colorClass: 'accent',
                });

                this.cd.markForCheck();
            }, 2000);
        } else if (this.demoTriggers === 1) {
            this.demoTriggers++;

            setTimeout(() => {
                this.notifications.unshift({
                    icon: 'shopping_basket',
                    name: 'User bought Exodus',
                    time: '23 min ago',
                    read: false,
                    colorClass: 'primary'
                });

                this.cd.markForCheck();
            }, 2000);
        }
    }
}
